import React, { useEffect, useState } from "react";
import SettingsEmptyState from './SettingsEmptyState';
import {
  ConfirmDelete,
  MwInputText,
  MwSpinner,
  MwSpinnerButton,
} from "../ui";
import { IoMdAdd } from "react-icons/io";

import MwSelectorAccount from "../ui/MwSelectorAccount";
import { useTranslation } from "react-i18next";
import { AiOutlineDelete } from "react-icons/ai";
import { useCurrent, useDelete, useFetch, usePost, usePut } from "../../hooks";
import { NewButton } from "../ui/NewButton";
import { BiSolidMessageSquareEdit } from "react-icons/bi";
import { NewInputLang } from "../ui/NewInputLang";

export const TypeOfexpensess = () => {
  const { t } = useTranslation("settings");
  const [langar, setLangar] = useState(true);
  const [expensesList, setexpenseList] = useState([]);
  const [expenseCode, setexpenseCode] = useState("");
  const [expenseName, setexpenseName] = useState("");
  const [expenseEnName, setexpenseEnName] = useState("");
  const [error, setError] = useState({});
  const [onShow, setOnShow] = useState(false);
  const [selectedexpenseId, setSelectedexpenseId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingexpenseId, setEditingexpenseId] = useState(null);
  const { currentTenantId, currentCompanyId, currentBranchId , currentLangId } = useCurrent();
  const { data, postData, loading } = usePost();
  const { loading: delloading, deleteItem } = useDelete();
  const {
    data: expensesResult,
    loading: loadingexpenses,
    refreshHandler: refetchexpenses,
  } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/expenses-types/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const {
    data: expensesCountResult,
    loading: loadingCountResult,
    refreshHandler,
  } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/expenses-types/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const {
    data: savedata,
    loading: saveloading,
    error: saveerr,
    putData,
  } = usePut();

  useEffect(() => {
    if (expensesCountResult && !isEditing) {
      setexpenseCode((parseInt(expensesCountResult?.data) + 1).toString());
    }
  }, [expensesCountResult, isEditing]);

  useEffect(() => {
    if (expensesResult?.data) {
      setexpenseList(expensesResult.data);
    }
  }, [expensesResult]);

  const addexpense = () => {
    let errors = {};

    if (!expenseCode) errors.code = "Code Is Required";
    if (langar && !expenseName) {
      errors.name_ar = "Arabic And English Name Is Required";
    }
    if (!langar && !expenseEnName) {
      errors.name_en = "English And Arabic Name Is Required";
    }

    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    const expenseData = {
      code: expenseCode,
      name_ar: expenseName || "-",
      name_en: expenseEnName || "-",
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
    };

    const resetForm = () => {
      setexpenseCode("");
      setexpenseName("");
      setexpenseEnName("");
      setIsEditing(false);
      setEditingexpenseId(null);
      setError({});
    };

    if (!isEditing) {
      postData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/expenses-types`,
        expenseData
      ).then(() => {
        refetchexpenses();
        refreshHandler();
        resetForm();
      });
    } else {
      putData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/expenses-types/${editingexpenseId}`,
        expenseData,
        "settings"
      ).then(() => {
        refetchexpenses();
        refreshHandler();
        resetForm();
      });
    }
  };

  const deleteexpense = (id) => {
    deleteItem(
      `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/expenses-types/${id}`
    ).then(() => {
      refetchexpenses();
      refreshHandler();
      setOnShow(false);
    });
  };

  return (
    <>
      {!expenseCode ? (
        <div className="h-20 w-full justify-center items-center flex">
          <MwSpinnerButton />
        </div>
      ) : (
        <section className="flex flex-col flex-1">
          <ConfirmDelete
            onShow={onShow}
            setOnShow={setOnShow}
            onDeleteHandler={() => deleteexpense(selectedexpenseId)}
            loading={delloading}
            msg={t("expense.expensedel")}
          />
          <div className="flex justify-start w-full items-end gap-2">
            <div className="w-28">
              <MwInputText
                invalid={error?.code}
                disabled={true}
                label={t("expense.expensecode")}
                value={expenseCode}
                onChange={(e) => setexpenseCode(e.target.value)}
                classNameInput="w-[100%] text-center  flex-1  "
              />
            </div>
            <div className="w-80 flex flex-col justify-center">
              <NewInputLang
                invalid={error?.name_ar || error?.name_en}
                placeholder={t("expense.expensenameplaceholder")}
                label={t("expense.expensename")}
                value={langar ? expenseName : expenseEnName}
                langar={langar}
                onChange={(value) => {
                  if (langar) {
                    setexpenseName(value);
                  } else {
                    setexpenseEnName(value);
                  }
                }}
                onChangeLang={() => setLangar(!langar)}
                classNameInput="w-[100%] flex-1"
              />
            </div>

            <div className="group">
              <NewButton onClick={addexpense}>
                {loading || saveloading ? (
                  <MwSpinnerButton />
                ) : isEditing ? (
                  t("general.update")
                ) : (
                  <>
                    <IoMdAdd className="text-white text-lg group-hover:text-[#ffffff]" />
                    <p className="">{t("general.Add")}</p>
                  </>
                )}
              </NewButton>
            </div>
          </div>

          {loadingexpenses && expensesList?.length === 0 ? (
            <div className="h-40 flex justify-center items-center w-full">
              {" "}
              <MwSpinnerButton />
            </div>
          ) : expensesList?.length > 0 ? (
            <>
              <>
                <div className="flex w-full mt-3 justify-around bg-[#F2F0FC] p-3 rounded-t-lg font-[800] text-[#251658] text-sm">
                  <div className="w-0 text-center">#</div>
                  <div className="w-52 text-center">
                    {t("expense.expensecode")}
                  </div>
                  <div className="flex-1 text-center">
                    {t("expense.expensename")}
                  </div>
              
                  <div className="flex-1 text-center"></div>
                </div>
                <div className="divide-y  ">
                  {expensesList.map((item, index) => (
                    <div
                      key={index}
                      className="flex w-full border-b border-[#ddd0bf] border-opacity-25 cursor-pointer justify-around items-center p-3 text-[#251658] font-semibold text-sm"
                    >
                      <div className="w-1 text-center">{index + 1}</div>
                      <div className="w-52 text-center">{item?.code}</div>
                      <div className=" flex-1 text-center">
                        {  currentLangId==="ar" ?  item?.name_ar : item?.name_en}
                      </div>
                  
                      <div className=" flex me-4 justify-end items-center flex-1 text-end gap-1">
                        <button
                          onClick={() => {
                            setIsEditing(true);
                            setEditingexpenseId(item.id);
                            setexpenseCode(item.code);
                            setexpenseEnName(item.name_en);
                            
                            setexpenseName(
                              item.name_ar
                            );
                          }}
                          className="text-blue-500 hover:text-blue-700 mx-2"
                        >
                          <img
                            className="w-4"
                            src="/assets/icons/Edit.png"
                            alt="delete"
                            srcSet=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            setSelectedexpenseId(item.id);
                            setOnShow(true);
                          }}
                          className="text-red-500 hover:text-red-700"
                        >
                          <img
                            className="w-4"
                            src="/assets/icons/Trash.png"
                            alt="delete"
                            srcSet=""
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            </>
          ) : (
              <div className=" h-[calc(100vh-230px)] ">
                        <SettingsEmptyState msg={t('expense.validate')} />
                        </div> 
          )}
        </section>
      )}
    </>
  );
};
